import { createStackNavigator } from '@react-navigation/stack'
import { Header } from '../comps/Header'
import { AgentAuthScreen } from '../screens/AgentAuthScreen'
import { BalanceEnquiryScreen } from '../screens/BalanceEnquiryScreen'
import { CashWOrDScreen } from '../screens/CashWOrDScreen'
import { CashWithdrawalStatusScreen } from '../screens/CashWithdrawalStatusScreen'
import { FundTransferScreen } from '../screens/FundTransferScreen'
import { HomeScreen } from '../screens/HomeScreen'
import { EnterAadhaarNoScreen } from '../screens/LinkAadhaarScreen/EnterAadhaarNoScreen'
import { EnterAadhaarOtpScreen } from '../screens/LinkAadhaarScreen/EnterAadhaarOtpScreen'
import { EnterMobileNoScreen } from '../screens/LinkAadhaarScreen/EnterMobileNoScreen'
import { EnterMobileOtpScreen } from '../screens/LinkAadhaarScreen/EnterMobileOtpScreen'
import { MiniStatementScreen } from '../screens/MiniStatementScreen'
import { ReviewCashWithdrawalScreen } from '../screens/ReviewCashWithdrawalScreen'
import { ReviewFundTransferScreen } from '../screens/ReviewFundTransferScreen'
import { StatementListScreen } from '../screens/StatementListScreen'
import { TransactionEnquiryScreen } from '../screens/TransactionEnquiryScreen'
import { AepsScanQrCode } from '../screens/aepsScanQR'
import { Screens } from './Screens'

export const HomeStack = () => {
  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{
        headerTitle: 'AePS Services',
        header: Header,
        cardStyle: { flex: 1 },
      }}>
      <Stack.Screen name={Screens.HOME_SCREEN} component={HomeScreen} />
      <Stack.Screen name={Screens.CASH_W_OR_D_Screen} component={CashWOrDScreen} />
      <Stack.Screen name={Screens.BALANCE_ENQUIRY} component={BalanceEnquiryScreen} />
      <Stack.Screen name={Screens.FUND_TRANSFER} component={FundTransferScreen} />
      <Stack.Screen name={Screens.MINI_STATEMENT} component={MiniStatementScreen} />
      <Stack.Screen name={Screens.TRANSACTION_ENQUIRY} component={TransactionEnquiryScreen} />
      <Stack.Screen name={Screens.STATEMENT_LIST} component={StatementListScreen} />
      <Stack.Screen name={Screens.REVIEW_CASH_WITHDRAWAL} component={ReviewCashWithdrawalScreen} />
      <Stack.Screen name={Screens.CASH_WITHDRAWAL_STATUS} component={CashWithdrawalStatusScreen} />
      <Stack.Screen name={Screens.REVIEW_FUND_TRANSFER} component={ReviewFundTransferScreen} />
      <Stack.Screen name={Screens.ENTER_CUSTOMER_MOBILE} component={EnterMobileNoScreen} />
      <Stack.Screen name={Screens.ENTER_CUSTOMER_MOBILE_OTP} component={EnterMobileOtpScreen} />
      <Stack.Screen name={Screens.ENTER_CUSTOMER_AADHAAR} component={EnterAadhaarNoScreen} />
      <Stack.Screen name={Screens.ENTER_CUSTOMER_AADHAAR_OTP} component={EnterAadhaarOtpScreen} />
      <Stack.Screen name={Screens.AGENT_AUTH_SCREEN} component={AgentAuthScreen} />
      <Stack.Screen name={Screens.SCAN_QR} component={AepsScanQrCode} />
    </Stack.Navigator>
  )
}
